/// <amd-module name="Artifacts/Maven/redux/Actions" />
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  IDeleteActionPayload,
  IPromoteActionPayload,
  IRestoreActionPayload,
  IUpstreamOverrideActionPayload,
} from "Artifacts/Root/Protocols/types/ICommandActionPayloads";
import { trackActionWithCount } from "Artifacts/Root/redux/Actions";
import { IFeed, IPackageVersionIdentity } from "Artifacts/Root/types";
import { ActionsUnion, createAction, trackedAction } from "redux/Utils/ActionHelper";

export const enum MavenActionTypes {
  Promote = "Artifacts/Maven/Promote",
  PermanentDelete = "Artifacts/Maven/PermanentDelete",
  Restore = "Artifacts/Maven/Restore",
  SoftDelete = "Artifacts/Maven/SoftDelete",
  SetUpstreamOverride = "UpstreamOverride",
}

export const MavenActions = {
  promote: (
    feed: IFeed,
    versions: IPackageVersionIdentity[],
    viewId: string,
    onSuccessCallback: () => void,
  ) =>
    trackActionWithCount(
      createAction<MavenActionTypes, IPromoteActionPayload>(MavenActionTypes.Promote, {
        feed,
        versions,
        viewId,
        onSuccessCallback,
      }),
      versions.length,
    ),
  permanentDelete: (
    feed: IFeed,
    versions: IPackageVersionIdentity[],
    onSuccessCallback: () => void,
  ) =>
    trackActionWithCount(
      createAction<MavenActionTypes, IDeleteActionPayload>(MavenActionTypes.PermanentDelete, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  restore: (feed: IFeed, versions: IPackageVersionIdentity[], onSuccessCallback: () => void) =>
    trackActionWithCount(
      createAction<MavenActionTypes, IRestoreActionPayload>(MavenActionTypes.Restore, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  softDelete: (feed: IFeed, versions: IPackageVersionIdentity[], onSuccessCallback: () => void) =>
    trackActionWithCount(
      createAction<MavenActionTypes, IDeleteActionPayload>(MavenActionTypes.SoftDelete, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  setUpstreamOverride: (
    feed: IFeed,
    packageName: string,
    allowExternalVersions: boolean,
    onSuccessCallback: () => void,
  ) =>
    trackedAction(
      createAction<MavenActionTypes, IUpstreamOverrideActionPayload>(
        MavenActionTypes.SetUpstreamOverride,
        { feed, packageName, allowExternalVersions, onSuccessCallback },
      ),
    ),
};

export type MavenActionsUnion = ActionsUnion<typeof MavenActions>;
